import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import { ref, watch, computed, PropType } from "vue";
  import { QSelect } from "quasar";

  import vehicleService from "src/services/vehicle-service";

  import { useHideLoading, useLoading, useDialog, useCurrencyFormatter } from "src/functions";
  import { Vehicle } from "src/types/loan-application/index";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleLookup',
  props: {
    icon: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    vehicles: {
      type: Array as PropType<Vehicle[]>,
      default: []
    }
  },
  emits: ['vehicleFound'],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const vehicleLookup = ref<QSelect | null>(null);
  function focus() {
    vehicleLookup.value!.focus()
  }
  __expose({
    focus
  })
  const options = computed(() => {
    let op = JSON.parse(JSON.stringify(props.vehicles)) as (Vehicle | null)[];
    op.push(null);
    return op;
  })

  const reg = ref("");
  const emit = __emit

  function vrmSearch() {
    useLoading("Finding vehicle details, please wait...");
    vehicleService.vehicleLookup(typedReg.value).then(res => {
      if ((res.vehicleDateOfFirstReg && new Date().getFullYear() - new Date(res.vehicleDateOfFirstReg).getFullYear() > 15)
        || (res.year && new Date().getFullYear() - res.year > 15)) {
        useDialog("Information", "Vehicle registration age must be less than 15 years");
        return;
      }
      emit('vehicleFound', res);
    }).catch(error => {
      useDialog("Error", "No vehicle details found");
    }).finally(() => {
      useHideLoading();
    })
  }

  const typedReg = ref("");
  const filteredOptions = ref(options.value);
  function filterFn(val: string, update: Function) {
    typedReg.value = val.toUpperCase();

    if (val === '') {
      update(() => {
        filteredOptions.value = options.value;
      })
      return
    }

    update(() => {
      const searchTerm = val.toLowerCase().replace(/ /g, "");
      filteredOptions.value = options.value.filter(v =>
        !v ||
        (v.make.toLowerCase().replace(/ /g, "") + v.model.toLowerCase().replace(/ /g, "")).indexOf(searchTerm) > -1 ||
        v.vehicleRegistration.toLowerCase().replace(/ /g, "").indexOf(searchTerm) > -1)
    })
  }

  const selectedVehicle = ref<Vehicle | null>(null);
  function selectVehicle(vehicle: Vehicle) {
    reg.value = vehicle.vehicleRegistration;
    emit('vehicleFound', vehicle);
  }


return (_ctx: any,_cache: any) => {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(QSelect), {
      outlined: "",
      dense: "",
      ref_key: "vehicleLookup",
      ref: vehicleLookup,
      "hide-dropdown-icon": "",
      "use-input": "",
      modelValue: reg.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reg).value = $event)),
      placeholder: reg.value === '' ? __props.placeholder : '',
      "popup-content-class": "text-body2 limit-vehicle-dd-height",
      options: filteredOptions.value,
      onFilter: filterFn
    }, {
      option: _withCtx((scope) => [
        (scope.opt)
          ? (_openBlock(), _createBlock(_component_q_item, _mergeProps({ key: 0 }, scope.itemProps, {
              onClick: ($event: any) => (selectVehicle(scope.opt))
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_badge, { class: "bg-reg-yellow text-dark text-subtitle2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.opt.vehicleRegistration), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_item_label, { class: "text-subtitle2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.opt.make) + " " + _toDisplayString(scope.opt.model), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_q_item_label, { class: "text-body2 q-mt-none" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.opt.mileage ? scope.opt.mileage.toLocaleString() : 0) + " mi ", 1),
                        (scope.opt.vehicleDateOfFirstReg)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_1, " - " + _toDisplayString(new Date(scope.opt.vehicleDateOfFirstReg).getFullYear()), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_item_section, {
                  side: "",
                  class: "text-subtitle2 text-dark"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(useCurrencyFormatter)(scope.opt.price, 2, 2)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1040, ["onClick"]))
          : _withDirectives((_openBlock(), _createBlock(_component_q_item, _mergeProps({
              key: 1,
              clickable: "",
              class: "text-primary text-subtitle1"
            }, scope.itemProps, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (typedReg.value === '' ? null : vrmSearch()))
            }), {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { side: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "mdi-magnify",
                      color: "primary"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(typedReg.value === '' ? 'Enter registration' : typedReg.value.toUpperCase()), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1040)), [
              [_directive_ripple]
            ]),
        _createVNode(_component_q_separator)
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder", "options"])
  ], 64))
}
}

})